/**
 * @fileoverview The two modes, and the copy that goes with each.
 * @module lib/domain/modes
 */

import { AppMode } from "@/types/types"

/** Every mode, in switch order. */
export const MODES: readonly AppMode[] = [AppMode.PEAK, AppMode.TESTO]

/** The mode the app starts in, before anything is stored. */
export const DEFAULT_MODE: AppMode = AppMode.PEAK

/** Full name of each mode, as shown in the interface. */
export const MODE_LABEL: Readonly<Record<AppMode, string>> = {
	[AppMode.PEAK]: "Peak Maxxing",
	[AppMode.TESTO]: "Testo Maxxing",
}

/** First word of each mode — the one the brand title plays with. */
export const MODE_WORD: Readonly<Record<AppMode, string>> = {
	[AppMode.PEAK]: "Peak",
	[AppMode.TESTO]: "Testo",
}

/** One-line pitch of each mode, used as the illustration's description. */
export const MODE_TAGLINE: Readonly<Record<AppMode, string>> = {
	[AppMode.PEAK]: "La montagne ne bouge pas. Toi si.",
	[AppMode.TESTO]: "La fonte ne ment jamais.",
}

/**
 * Narrows an unknown value to a mode.
 *
 * @param value - Any value, typically read from storage or a URL.
 * @returns True when the value is one of the supported modes.
 */
export function isAppMode(value: unknown): value is AppMode {
	return value === AppMode.PEAK || value === AppMode.TESTO
}

/**
 * The mode the switch flips to.
 *
 * @param mode - The active mode.
 * @returns The other one.
 *
 * @example
 * otherMode(AppMode.PEAK) // => "testo"
 */
export function otherMode(mode: AppMode): AppMode {
	return mode === AppMode.PEAK ? AppMode.TESTO : AppMode.PEAK
}
